import React, { useContext, useRef, useEffect } from "react";
import { Context as AISearchContext } from "./context";
import { AISearchFAB, AISearchWrapper } from "./styles";
import Drawer from "components/drawer";
import { Context as DrawerContext } from "components/drawer/context";
import { useAIFeature } from "hooks/useAIFeature";
import { ChatUI } from "./ChatUI";

/**
 * AI Search component with chat interface.
 *
 * Renders nothing at all on sites without ai.assistant.enabled: the FAB floats
 * over every page in the admin, so an editor at a publication that has not
 * bought this must never see it, let alone open a drawer that can only report
 * the assistant is off.
 */
const AISearch = () => {
  const assistantEnabled = useAIFeature('assistant');
  const { isDrawerOpen, setIsDrawerOpen } = useContext(AISearchContext);
  const { show, toggleShow, closeDrawer } = useContext(DrawerContext);
  const fabRef = useRef(null);

  // Listen to drawer state changes
  useEffect(() => {
    const isOpen = show.includes('ai-search');
    setIsDrawerOpen(isOpen);
  }, [show, setIsDrawerOpen]);

  const handleClick = () => {
    toggleShow("ai-search", true);
  };

  // After the hooks above, never before them -- the gate must not change how
  // many hooks this component runs.
  if (!assistantEnabled) return null;

  return (
    <AISearchWrapper id="ai-search">
      <Drawer id="ai-search" title="AI Assistant" size="wide">
        <ChatUI />
      </Drawer>
      <AISearchFAB ref={fabRef} onClick={handleClick} $hidden={isDrawerOpen} />
    </AISearchWrapper>
  );
};

export default AISearch;
